import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdministrationResultStatus } from 'src/app/clients/system-api/SystemApiClient';
import { ShiftTemplateService } from 'src/app/services/shift-template.service';
import { TermService } from 'src/app/services/term.service';

@Component({
  selector: 'app-delete-component',
  templateUrl: './delete-component.component.html',
  styleUrls: ['./delete-component.component.scss']
})
export class DeleteComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();
  @Input() termId?: number;
  @Input() shiftTemplateId?: number;

  @Input() serviceName?: string;

  constructor(private _snackBarService: SnackBarService,
    private shiftTemplateService: ShiftTemplateService,
    private termService: TermService,
  ) { }

  ngOnInit(): void { }

  closePopup() { this.close.emit(); }

  deleteFunction() {
    if (this.serviceName == 'shiftTemplate') {
      this.shiftTemplateService.deleteShiftTemplate(this.shiftTemplateId).subscribe((data) => {
        this._snackBarService.callSnackBar(data, "Successfully deleted");
        if (data == AdministrationResultStatus.Success) {
          this.closePopup();
        }
      }, error => {
        this._snackBarService.callSnackBar(error);
      });
    }
    if (this.serviceName == 'cancelTerm') {
      this.termService.cancelTerm(this.termId).subscribe((data) => {
        this._snackBarService.callSnackBar(data, "Successfully canceled");
        if (data == AdministrationResultStatus.Success) {
          this.closePopup();
        }
      }, error => {
        this._snackBarService.callSnackBar(error);
      });
    }
  }

}
